// Application Constants

// File Upload
export const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2MB in bytes
export const MAX_AVATAR_SIZE = 2 * 1024 * 1024 // 2MB in bytes
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg']

// Polling & Timeouts
export const SCRAPING_POLL_INTERVAL = 5000 // 5 seconds
export const TOAST_TIMEOUT = 5000 // 5 seconds

// Pagination
export const DEFAULT_ITEMS_PER_PAGE = 5
export const MAX_ITEMS_PER_PAGE = 100

// Password
export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 72

// Widget
export const DEFAULT_REVIEW_COUNT = 5
export const MAX_REVIEW_COUNT = 50

// Review Ratings
export const MIN_RATING = 1
export const MAX_RATING = 5

// Subscription Plans
export const PLANS = {
  FREE: 'free',
  PREMIUM: 'premium',
  ENTERPRISE: 'enterprise'
}

// Subscription Status
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired'
}

// Billing Cycles
export const BILLING_CYCLES = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
}

// Widget Templates
export const WIDGET_TEMPLATES = {
  CARD: 'card',
  LIST: 'list',
  CAROUSEL: 'carousel',
  GRID: 'grid',
  MINIMAL: 'minimal',
  MODERN: 'modern',
  CLASSIC: 'classic'
}

// Business Scraping Status
export const SCRAPING_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  SCRAPING: 'scraping',
  COMPLETED: 'completed',
  FAILED: 'failed'
}

// HTTP Status Codes (for reference)
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500
}
